import { z } from 'zod';
import { UserModelSchema } from '@/types/models/user';

/** POST /login response data for an existing account. */
export const LoginResponseSchema = z.object({
  id: z.string().uuid(),
  username: z.string(),
  idle_expires_in_seconds: z.number(),
});

// Inferred TypeScript types
export type User = z.infer<typeof UserModelSchema>;
export type LoginResponse = z.infer<typeof LoginResponseSchema>;

// Backward compatibility - keep the interface name
export type LoginResponseType = LoginResponse;
